import React, { createContext, useContext, useState } from 'react';

const GlobalContext = createContext<{
	scrollY: number
	setScrollY: React.Dispatch<React.SetStateAction<number>>
} | undefined>(undefined);

export const GlobalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

	const
	[scrollY, setScrollY] = useState<number>(0);

	return (
		<GlobalContext.Provider value={{ 
			scrollY, setScrollY
		}}>
			{children}
		</GlobalContext.Provider>
	);
};

export const useGlobalContext = () => {
	const context = useContext(GlobalContext);
	if (!context) {
		throw new Error('useGlobalContext must be used within a GlobalProvider');
	}
	return context;
};